/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'hourglass': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M735.616 216.346H693.12v142.003c0 68.813-37.325 120.857-117.376 161.613 83.098 42.035 118.042 93.696 118.042 170.726 0 50.202-.23 92.288-.384 115.43h42.24a21.094 21.094 0 0 1 0 42.164h-423.27a21.094 21.094 0 0 1 0-42.164h43.52c-.154-23.04-.385-65.254-.385-115.43 0-77.056 34.458-128.691 117.427-170.726-79.897-40.756-116.761-92.8-116.761-161.613V216.346h-43.75a21.094 21.094 0 0 1 0-42.164h423.244a21.094 21.094 0 1 1 0 42.164zm-337.92 474.342c0 50.278.23 92.442.384 115.43h253.21c.153-23.04.384-65.152.384-115.43 0-58.65-21.837-104.166-127.335-147.917-105.523 43.776-126.745 89.293-126.745 147.917zm253.44-474.342H398.464v142.003c0 40.448 13.62 92.57 126.003 138.752 112.41-46.08 126.669-98.304 126.669-138.752z"/><path pid="1" d="M466.458 647.962c0 25.881 0 47.564.204 59.417h125.261c0-11.827.205-33.536.205-59.417 0-30.183-13.414-53.76-65.613-76.34-52.07 22.58-60.057 46.106-60.057 76.34z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/hourglass.js